import React from 'react'
import { AppDataTable, AppTableSkeleton } from '@components'
import { useGroupedExportsModal } from 'Pages/ReportsAlerts/ExportsGrouping/@hooks'
import { reportNameColumn, officeDataColumn, exportUrlColumn } from 'Pages/ReportsAlerts/ExportsGrouping/Modal/Table/@columns'


export default function GroupingExportModalTable() {
	const { data, isLoading } = useGroupedExportsModal()

	if (isLoading) return <AppTableSkeleton rows={14} columns={4}/>

	return <AppDataTable title="" data={data} columns={[ ...reportNameColumn(), ...officeDataColumn(), ...exportUrlColumn() ]}/>

}